module.exports = __webpack_public_path__ + "img/planting_03@2x.2bf7119.jpg";